module.exports = __webpack_public_path__ + "img/fim-checkout.b1b676dd.svg";